define('apps/admin/views/modals/unarchive_user_confirm',[
        'app',
        'njs!apps/admin/templates/includes/modals/_unarchive_user_confirm(params:tmpl=admin/main/includes/modals/_unarchive_user_confirm.html)',
    ], function(app, template) {
        'use strict';

        return Mn.ItemView.extend({

            "events": {
                "click .comet-modal__button--cancel": "closeModal",
                "click .comet-modal-overlay--backdrop": "closeModal",
            },

            "template": template,

            "initialize": function(opts){
                this.model.set({
                    'unarchive_token': app.initData.get('unarchive_token'),
                    'endpointShortname': app.initData.get('endpoint_shortname'),
                    'nextUrl': window.location.href
                });
            },

            "closeModal": function(event) {
                this.destroy();
            },

        });

});

